import { render } from "./HomeView.vue?vue&type=template&id=4901a8ba"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=4901a8ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__